module.exports = __webpack_public_path__ + "img/sh.9777e158.svg";